import { render, staticRenderFns } from "./AlertSummary.vue?vue&type=template&id=7af561cb&"
import script from "./AlertSummary.vue?vue&type=script&lang=ts&"
export * from "./AlertSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports